import React from 'react';
import ReactDOM from 'react-dom';
import './rating-select.css';

class RatingSelect extends React.Component {
    constructor(props){
        super(props)
        this.ratings = [1, 2, 3, 4, 5];
        this.value = this.props.value;
        this.onChange = this.onChange.bind(this)
    }

    onChange(e, rating) {
        if (e.target.checked) {
            // add the rating in value
            if(this.value.indexOf(rating) == -1)
                this.value.push(rating)
        } else {
            // remove the rating from value
            this.value = this.value.filter(el => el !== rating);
        }

        this.value.sort((a,b)=>a-b) // Sort numerically because default is lexicographical sort:
        
        // call the parent onChange method, received as prop
        if(this.props.onChange != undefined){
            this.props.onChange(this.value);  
        }

        // because we don't change the state we need to force rerendering
        this.forceUpdate();
    }

    render() { 
        if(this.props.externalValue != undefined){
            this.value = this.props.value
        }

        return <div className="rating-component">
            {this.ratings.map((rating, i) => {
                return <label className="star-container" key={"star" + i}>

                    {this.value.indexOf(rating) !=-1 || !this.value  
                        ? <input name={this.props.name} type="checkbox" value={rating} onChange={ e => this.onChange(e, rating)} checked defaultChecked></input>
                        : <input name={this.props.name} type="checkbox" value={rating} onChange={ e => this.onChange(e, rating)}></input>
                    }
                    
                    <span className="fa-stack fa-lg star star-full" title={"Hide " + rating + " star review"}>
                        <i className="fa fa-star fa-stack-1x"></i>
                        <span className="fa-layers-text fa-inverse fa-stack-1x rating">{rating}</span>
                    </span>
                    <span className="fa-stack fa-lg star star-empty" title={"Show " + rating + " star review"}>
                        <i className="fa fa-star-o fa-stack-1x"></i>
                        <span className="fa-layers-text fa-stack-1x rating">{rating}</span>
                    </span>
                </label>
            })}
        </div>
    }
}

export default RatingSelect